export const scrollNav = {
  data() {
    return {
      lastScrollPosition: 0,
      lastScrollPositionForCity: 0,
      showNavbar: true,
      showCitySelect: false,
      offset: 24,
      offsetCitySelect: 200,
      currentScrollPosition: 0,
    }
  },
  created() {
    //scroll
    this.lastScrollPosition = window.pageYOffset;
    // [TOGGLE] on scroll hide bottom navbar
    window.addEventListener("scroll", this.onScroll);
    // window.addEventListener("scroll", this.onScrollShowCity);
  },
  methods: {
    // scroll
    onScroll() {
      this.currentScrollPosition = window.pageYOffset
      // if (!this.isPWAinBrowser) return;
      if (window.pageYOffset < 0) {
        return;
      }
      if (
        Math.abs(window.pageYOffset - this.lastScrollPosition) < this.offset
      ) {
        return;
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.$store.commit('ui/TOGGLE_NAVBAR', this.showNavbar)
      this.lastScrollPosition = window.pageYOffset;


      // show city

      this.showCitySelect = window.pageYOffset > this.offsetCitySelect;
      this.$store.commit('ui/TOGGLE_CITY_SELECT', this.showCitySelect)
      this.lastScrollPositionForCity = window.pageYOffset; 

    },
    onScrollShowCity() {

      this.showCitySelect = window.pageYOffset > this.offsetCitySelect;
      this.$store.commit('ui/TOGGLE_CITY_SELECT', this.showCitySelect)
      this.lastScrollPositionForCity = window.pageYOffset; 
    }
    // ./scroll
  },
  
}